import { Badge } from '../../../ui/badge';
import {
    hasPendingSiteAdminInvitation,
    type Facility,
} from '../../utils/utils';

interface AdminStatusCellProps {
    facility: Facility;
    showPending?: boolean;
}

export default function AdminStatusCell({
    facility,
    showPending = true,
}: AdminStatusCellProps) {
    if (facility.admin) {
        return (
            <span className="text-xs text-foreground">
                {facility.admin.name || facility.admin.email}
            </span>
        );
    }

    if (showPending && hasPendingSiteAdminInvitation(facility)) {
        return (
            <Badge
                variant="outline"
                className="rounded-full border-amber-400/20 bg-amber-400/5 px-2 py-0.5 text-xs font-medium text-amber-300"
            >
                Pending
            </Badge>
        );
    }

    return (
        <Badge
            variant="outline"
            className="rounded-full border-white/10 bg-white/5 px-2 py-0.5 text-xs font-medium text-muted-foreground"
        >
            {showPending ? 'Not invited' : 'Not assigned'}
        </Badge>
    );
}
